import { createSlice } from '@reduxjs/toolkit';

const initialState = "progression_container large startBottom";

const scrollSlice = createSlice({
    name: "scroll",
    initialState,
    reducers: {
        classAdded(state, action) {         
            return state = action.payload;
        }
    }
});

export const scrollSelector = (state) => state.scroll;

export const { classAdded } = scrollSlice.actions;
export default scrollSlice.reducer;